import React, { useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { toast } from 'react-toastify';
import Topbar from '../../layouts/Topbar';
import Sidebar from '../../layouts/Sidebar';
import { API_BASE_URL } from '../../../config/api';

const AddKRA = () => {
  const baseUrl = API_BASE_URL;
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '',
    percentage: '',
    year: ''
  });

  // Generate years: current year and following year
  const currentYear = new Date().getFullYear();
  const years = [currentYear, currentYear + 1];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(form);
    try {
      const token = Cookies.get('token');
      await axios.post(`${baseUrl}/api/key-result-areas/`, {
        name: form.name,
        percentage: parseInt(form.percentage),
        year: parseInt(form.year)
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      toast.success('Key Result Area created successfully!');
      setForm({
        name: '',
        percentage: '',
        year: ''
      });
    } catch (err) {
      console.log(err);
      toast.error(err.response?.data?.detail || 'Key Result Area with this name already exist');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-sidebar-skin="dark" data-header-skin="light" data-navbar-brand-skin="dark" data-sidebar-state="expand">
      <Topbar />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content pb-0">
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
            <div>
              <h4 className="fw-bold mb-1">Add Key Result Area</h4>
              <p className="text-muted mb-0 fs-13">Create a new Key Result Area for performance management</p>
            </div>
          </div>

          {/* Form Card */}
          <div className="card shadow-sm mb-4">
            <div className="card-header bg-light border-bottom py-3">
              <h6 className="card-title mb-0 fw-bold text-dark">KRA Details</h6>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-medium">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="form-control"
                    placeholder="Enter KRA name"
                    disabled={loading}
                  />
                </div>

                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label className="form-label fw-medium">
                      Percentage <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      name="percentage"
                      value={form.percentage}
                      onChange={handleChange}
                      required
                      className="form-control"
                      placeholder="Enter percentage (0-100)"
                      min="0"
                      max="100"
                      disabled={loading}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-medium">
                      Year <span className="text-danger">*</span>
                    </label>
                    <select
                      name="year"
                      value={form.year}
                      onChange={handleChange}
                      required
                      className="form-select"
                      disabled={loading}
                    >
                      <option value="">Select Year</option>
                      {years.map(year => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <button
                    type="submit"
                    className="btn btn-primary d-inline-flex align-items-center gap-2"
                    disabled={loading || !form.name || !form.percentage || !form.year}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        <span>Creating KRA...</span>
                      </>
                    ) : (
                      <>
                        <i className="ti ti-device-floppy fs-18" />
                        <span>Create KRA</span>
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-between flex-column flex-sm-row row-gap-2 border-top py-2 px-3">
          <p className="text-dark mb-0">
            2026 © <span className="link-primary">Casoe Technologies</span>, All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default AddKRA;
